<main class="page-container__body">
    <div class="container">
        <div class="page-header toptoscroll">
            <h1>Why GovtTow Auctions</h1>
            <hr class="hr-highlight" />
        </div>
        <div class="row">
            <div class="col-md-12 col-xs-12">
                <p class="text2">
                   GovTow Auctions allows your organization to sell to a nationwide customer base, increasing demand and interest in your auction vehicles. Watch the value of vehicles rise as your organization is able to reach buyers that they have never been able to reach before.
                </p>
                <p class="text2">
                    GovTow Auctions allows customers to search vehicles up for auction nationwide, without the restrictions of geography. Customers will be able to find more of the vehicles they need, bringing them back to the site again and again and raising interest and value for both sellers and buyers.
                </p>
                <p class="text2">
                    GovTow Auctions also provides better advertisement opportunities and attention for your auctions, using the power of the web and search engine optimization. Ask us how we can drive demand to your auctions!
                </p>
<!--                 <p class="text2">
                    GovTow Auctions allows customers to search vehicles up for auction nationwide, without the restrictions of geography. Customers will be able to find more of the vehicles they need, bringing them back to the site again and again and raising interest and value for both sellers and buyers.
                </p>
                <p class="text2">
                    GovTow Auctions also provides better advertisement opportunities and attention for your auctions, using the power of the web and search engine optimization. Ask us how we can drive demand to your auctions!
                </p> -->
                <p class="text2">
                    Please <a routerLink="/contactus">Contact Us</a> to get started today!
                </p>
            </div>
        </div>
    </div>
</main>